export default "/public/dist/img/banner-3.png";